export default __webpack_public_path__ + "static/media/photo_gallery_1.8e7dc7c2.png";